<template>
  <component
    :is="ButtonVariant"
    :icon-pos="iconPos"
    :text="text"
    :outlined="outlined"
    :disabled="disabled"
    :loading="loading"
    :icon="icon"
    :variant="text ? 'text' : outlined ? 'outlined' : undefined"
    :type="type"
    :label="label"
    :class="{ 'w-full': fullWidth }"
    @click="onButtonClick"
  >
    <slot></slot>
  </component>
</template>
<script lang="ts" setup>
import Button from "@/volt/Button.vue";
import SecondaryButton from "@/volt/SecondaryButton.vue";
import ContrastButton from "@/volt/ContrastButton.vue";
import DangerButton from "@/volt/DangerButton.vue";
import GradientButton from "@/volt/GradientButton.vue";
import PlainButton from "@/volt/PlainButton.vue";
import type { ButtonHTMLAttributes } from "vue";
const router = useRouter();

const props = withDefaults(
  defineProps<{
    loading?: boolean;
    icon?: string;
    label?: string;
    variant?: "secondary" | "danger" | "success" | "gradient" | "plain";
    disabled?: boolean;
    text?: boolean;
    outlined?: boolean;
    fullWidth?: boolean;
    type?: ButtonHTMLAttributes["type"];
    iconPos?: "right" | "left";
    to?:
      | symbol
      | string
      | { name: symbol; query?: Record<string, any>; params?: Record<string, any> };
  }>(),
  {
    variant: undefined,
    iconPos: "right",
  }
);

const ButtonVariant = computed(() => {
  switch (props.variant) {
    case "secondary":
      return SecondaryButton;
    case "danger":
      return DangerButton;
    case "success":
      return ContrastButton;
    case "gradient":
      return GradientButton;
    case "plain":
      return PlainButton;
    default:
      return Button;
  }
});
function onButtonClick() {
  if (props.to) {
    router.push(typeof props.to === "symbol" ? { name: props.to } : props.to);
  }
}
</script>
